import { connect } from 'react-redux';
import { isCampaignEnabled } from './isCampaignEnabledSelector';
import Component from './';

const mapStateToProps = (_, ownProps) => ({
  isVisible: isCampaignEnabled(ownProps.id),
});

export const CampaignCard = connect(mapStateToProps)(Component);
